import React from "react";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import MenuBase from "./MenuBase";

const MenuContentZabihat = ({ open }) => {
  const menuItems = [
    { label: "Dashboard", icon: <HomeRoundedIcon />, path: "/dashboard" },
    { label: "Zabihat Receipts", icon: <ReceiptLongIcon />, path: "/zabihat-receipts" },
  ];

  return <MenuBase open={open} menuItems={menuItems} />;
};

export default MenuContentZabihat;
